var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"30px"}},[_c('el-alert',{attrs:{"closable":false,"title":"menu 1-2","type":"success"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }